export enum MapEvent {
  DATA_CHANGED = "DATA_CHANGED",
  SELECT_SEATS = "SELECT_SEATS",
  REFRESH_MAP = "REFRESH_MAP",
}
